<template>
    <div>
        <b-btn v-if="languages.length <= 2" @click="toggleLanguage()" class="btn-language" v-bind="$props"
            v-on="$listeners" :size="size" v-b-tooltip :title="'Change language|Changer de langue' | tr">
            <img class="flag" v-if="currentLanguage.flag" :src="currentLanguage.flag" />
            <img class="flag" v-else :src="getPublicIcon('flags/united-states')" />
            <i class="fas fa-caret-down"></i>
        </b-btn>

        <b-dropdown v-else class="select-language h-100" :class="{ 'btn-language': hideLabel }" v-bind="$props" v-on="$listeners" :size="hideLabel ? 'md' : size"
            :variant="variant || 'light'" no-caret>
            <template #button-content>
                <img class="flag" :src="currentLanguage.flag" />
                <span v-if="!hideLabel" class="ml-2 d-none d-md-inline">{{ currentLanguage.name }}</span>
                <i class="fas fa-caret-down" />
            </template>

            <b-dropdown-item v-for="lang in languages" :key="lang.locale" @click="selectLanguage(lang)">
                <div class="d-flex align-items-center px-3 w-100">
                    <img class="flag" :src="lang.flag" />
                    <div class="ml-2">{{ lang.name }}</div>
                    <div class="small ml-auto pl-4">{{ lang.locale }}</div>
                </div>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import { getSupportedLocales, getLanguageObject } from '@/../vue-components/helpers/I18nPluginHelper.js';

export default {
    name: `btn-language`,
    props: {
        value: { type: String },
        variant: { type: String },
        size: { type: String },
        block: { type: Boolean },
        locales: { type: Array },
        hideLabel: { type: Boolean }
    },
    computed: {
        currentLanguage: {
            get() {
                // Convert string locale to language object
                return getLanguageObject(this.value);
            },
            set(lang) {
                // Emit the locale string, not the object
                this.$emit(`input`, lang.locale);
            }
        },
        languages() {
            const supported = getSupportedLocales();
            const cmsLangs = this.locales || this.cmsWebsite?.settings?.languages || [];

            return supported.filter(loc => cmsLangs.includes(loc.locale));
        }
    },
    data() {
        return {};
    },
    methods: {
        toggleLanguage() {
            if (this.languages.length <= 2) {
                const first = this.languages[0];
                const second = this.languages[1];

                if (this.currentLanguage.locale === first.locale) {
                    this.currentLanguage = second;
                } else {
                    this.currentLanguage = first;
                }
                return;
            }
        },
        selectLanguage(lang) {
            this.currentLanguage = lang;
        },
    }
}
</script>

<style lang="scss" scoped>
.btn-language {
    position: relative;
    display: flex;

    .fa-caret-down {
        position: absolute;
        bottom: 0;
        right: 2px;
    }
}

:deep(.select-language) {
    .dropdown-item {
        min-width: 0 !important;
    }
}

.select-language-content {
    display: flex;
    align-items: center;
}

.btn-language,
.select-language {
    .flag {
        min-width: 24px;
        max-width: 24px;
        width: 24px;
        height: 16px;
        min-height: 16px;
        max-height: 16px;
        border-radius: 2px;
        overflow: hidden;
        object-fit: cover;
    }

    &.btn-language {
        outline: 1px solid var(--btn-border-color, #ced4da) !important;
        border-radius: 0.25rem 0 0 0.25rem !important;
    }

    &.btn-sm .flag {
        width: 20px;
        height: 20px;
    }

    &.btn-xs .flag {
        width: 16px;
        height: 16px;
    }
}
</style>
